export var COLLAPSED_ACCORDION_LABEL = 'collapse';
export var EXPANDED_ACCORDION_LABEL = 'expand';
